import { YmQueueFunction } from '@/lib/analytics/ym';

const YM_ID = import.meta.env.VITE_YANDEX_METRIKA_ID;
const MAIL_RU_ID = import.meta.env.VITE_MAIL_RU_COUNTER_ID;

let scriptsInjected = false;

export function loadAnalyticsScripts(analyticsAccepted: boolean) {
  if (
    !analyticsAccepted ||
    scriptsInjected ||
    typeof globalThis === 'undefined' ||
    !globalThis.document
  ) {
    return;
  }

  try {
    if (YM_ID) {
      const existingYm = globalThis.ym;
      const ymFn: YmQueueFunction = Object.assign(
        function (...args: unknown[]) {
          (ymFn.a = ymFn.a || []).push(args);
        },
        {
          a: existingYm?.a || [],
          l: Date.now(),
        },
      );
      globalThis.ym = ymFn;
      globalThis.dataLayer = globalThis.dataLayer || [];

      globalThis.ym(Number(YM_ID), 'init', {
        defer: true,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        ecommerce: 'dataLayer',
      });

      const ymScript = document.createElement('script');
      ymScript.type = 'text/javascript';
      ymScript.async = true;
      ymScript.src = 'https://mc.yandex.ru/metrika/tag.js';
      document.head.append(ymScript);

      const ymNoscript = document.createElement('noscript');
      ymNoscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${YM_ID}" style="position: absolute; left: -9999px" alt="" /></div>`;
      document.body.append(ymNoscript);
    }

    if (MAIL_RU_ID) {
      globalThis._tmr = globalThis._tmr || [];
      globalThis._tmr.push({
        id: MAIL_RU_ID,
        type: 'pageView',
        start: Date.now(),
      });

      const mailScript = document.createElement('script');
      mailScript.type = 'text/javascript';
      mailScript.async = true;
      mailScript.id = 'tmr-code';
      mailScript.src = 'https://top-fwz1.mail.ru/js/code.js';
      document.head.append(mailScript);

      const mailNoscript = document.createElement('noscript');
      mailNoscript.innerHTML = `<div><img src="https://top-fwz1.mail.ru/counter?id=${MAIL_RU_ID};js=na" style="position: absolute; left: -9999px" alt="Top.Mail.Ru" /></div>`;
      document.body.append(mailNoscript);
    }

    scriptsInjected = true;
  } catch (error) {
    console.error('Failed to load analytics scripts', error);
  }
}
